<template >
  <div class="q-pa-md" >

    <q-table
        v-table-resizable
        ref="stable"
        xtitle="Treats"
        class="my-sticky-virtscroll-table"
        virtual-scroll
        :key="clock"
        :dark="themeCtx=='dark'"
        :loading="loading"
        :data="dataProcessed"
        :columns="columnsProcessed"
        @virtual-scroll="onScroll"
        :row-key="workingKey"
        :style="'height:' +optimalHeight+'px'"
        :pagination.sync="pagination"
        :rows-per-page-options="[0]"
        :virtual-scroll-item-size="rowHeight"
        :virtual-scroll-sticky-size-start="48" >
      <template v-slot:header="props" >
        <q-tr :props="props" >
          <q-th
              v-for="col in props.cols"
              :key="col.name"
              :props="props"

              v-html="col.label" >

          </q-th >
        </q-tr >
      </template >
      <template v-slot:body-cell="props" >
        <q-td
            :props="props"
            @click="handleCellClick(props)"
            :class="cellClassProcessor(props)" >
          <QsTd
              :colProps="props" />
        </q-td >
      </template >
    </q-table >
    <!--    {{rawData}}-->
  </div >
</template >

<script >
import * as api from "~/api/resource";
import QsTd from "./QsTd";


let oldQuery = null;

class ResizableTable {
  constructor(table) {
    this.table = table;
    this.pageX = undefined;
    this.curCol = undefined;
    this.nxtCol = undefined;
    this.curColWidth = undefined;
    this.offsetWidth = undefined;
    this.nxtColWidth = undefined;
    this.divs = [];
    this.resizableTable(table);
  }

  destroy() {
    _log_("destroy");
    this.removeAllDivs();
  }

  clearState() {
    this.pageX = undefined;
    this.curCol = undefined;
    this.nxtCol = undefined;
    this.curColWidth = undefined;
    this.offsetWidth = undefined;
    this.nxtColWidth = undefined;
  }

  onMouseDown(e) {

    e.stopPropagation();
    e.preventDefault();
    this.curCol = e.target.parentElement;
    this.nxtCol = this.curCol.nextElementSibling;
    this.pageX = e.pageX;

    const padding = this.paddingDiff(this.curCol);

    this.offsetWidth = this.curCol.offsetWidth;
    this.curColWidth = this.offsetWidth - padding;
    if (this.nxtCol) {
      this.nxtColWidth = this.nxtCol.offsetWidth - padding;
    }
  }

  onMouseOver(e) {
    e.target.style.borderRight = "2px solid #c0c0c0";
  }

  onMouseOut(e) {
    e.target.style.borderRight = "";
  }

  onMouseMove(e) {
    if (this.curCol) {
      const diffX = e.pageX - this.pageX;

      if (this.nxtCol) {
        this.nxtCol.style.width = this.nxtColWidth - diffX + "px";
      }

      this.curCol.style.width = this.curColWidth + diffX + "px";
    }
  }

  onMouseUp(e) {
    this.clearState();
    e.stopPropagation();
    e.preventDefault();
  }

  setListeners(div) {
    div.addEventListener("mousedown", (e) => this.onMouseDown(e));
    div.addEventListener("mouseover", (e) => this.onMouseOver(e));
    div.addEventListener("mouseout", (e) => this.onMouseOut(e));
    document.addEventListener("mousemove", (e) => this.onMouseMove(e));
    document.addEventListener("mouseup", (e) => this.onMouseUp(e));
  }

  removeListener(div) {
    div.removeEventListener("mousedown", (e) => this.onMouseDown(e));
    div.removeEventListener("mouseover", (e) => this.onMouseOver(e));
    div.removeEventListener("mouseout", (e) => this.onMouseOut(e));
    document.removeEventListener("mousemove", (e) => this.onMouseMove(e));
    document.removeEventListener("mouseup", (e) => this.onMouseUp(e));
  }

  removeListeners() {
    this.divs.forEach((div) => this.removeListener(div));
  }

  createDiv(height) {
    const div = document.createElement("div");
    div.style.top = 0;
    div.style.right = 0;
    div.style.width = "5px";
    div.style.position = "absolute";
    div.style.cursor = "col-resize";
    div.style.userSelect = "none";
    div.style.height = height + "px";
    div.style.zIndex = 100;
    return div;
  }

  removeDiv(div) {
    if (div && div.parentElement)
      div.parentElement.removeChild(div);
  }

  removeAllDivs() {
    this.divs.forEach((div) => {
      this.removeListener(div);
      this.removeDiv(div);
    });
    this.divs.splice(0, this.divs.length);
  }

  paddingDiff(col) {
    const style = window.getComputedStyle(col, null);

    if (style.getPropertyValue("box-sizing") === "border-box") {
      return 0;
    }

    const padLeft = style.getPropertyValue("padding-left");
    const padRight = style.getPropertyValue("padding-right");
    return parseInt(padLeft, 10) + parseInt(padRight, 10);
  }

  getStyleVal(el, css) {
    return window.getComputedStyle(el, null)
                 .getPropertyValue(css);
  }

  resizableTable() {

    const rows = this.table.getElementsByTagName("tr"),
        cols = rows[0] ? rows[0].children : undefined;
    if (!cols) return;

    // table.style.overflow = 'hidden'

    const tableHeight = this.table.offsetHeight;

    for (let row = 0; row < rows.length; ++row) {
      const cols = rows[row] ? rows[row].children : [];
      for (let col = 0; col < cols.length; ++col) {
        if (row === 0) {
          const div = this.createDiv(tableHeight);
          this.divs.push(div);
          cols[col].appendChild(div);
          this.setListeners(div);
          // cols[col].style.position = "sticky";

        }
        cols[col].style.whiteSpace = "nowrap";
        cols[col].style.textOverflow = "ellipsis";
        // cols[col].style.overflow = 'hidden'
      }
    }


  }
}

function handleUpdate(el, binding) {
  const ctx = el.__tableResizable;
  const tables = el.getElementsByTagName("table");
  if (tables === undefined && ctx !== undefined) {
    // table turned into a grid?
    ctx.destroy();
    delete el.__tableResizable;
  }
  else if (tables !== undefined && ctx === undefined) {
    // new table
    setTimeout(() => {
      el.__tableResizable = new ResizableTable(tables[0]);
    }, 250);
  }
  else if (tables !== undefined && ctx !== undefined) {
    // use-case is columns added/removed
    // tear down old one and add new one
    ctx.destroy();
    delete el.__tableResizable;
    setTimeout(() => {
      el.__tableResizable = new ResizableTable(tables[0]);
    }, 250);
  }
}

const TableResizable = {
  name: "TableResizable",

  mounted(el, binding) {
    _log_("mounted", el, binding);
  },

  bind(el, binding) {
    _log_("bind", el, binding);
    handleUpdate(el, binding);
  },

  inserted(el, binding) {
    _log_("inserted");
  },

  updated(el, binding) {
    _log_("update");
  },

  componentUpdated(el, binding) {
    _log_("componentUpdated");
    handleUpdate(el, binding);
  },

  unbind(el) {
    _log_("unbind");
    const ctx = el.__tableResizable;
    if (ctx) {
      ctx.destroy();
      delete el.__tableResizable;
    }
  },

  beforeUnmount(el) {
    _log_("beforeUnmount");
    const ctx = el.__tableResizable;
    if (ctx) {
      ctx.destroy();
      delete el.__tableResizable;
    }
  }
};
export default {
  name: "SqTable",
  components: {QsTd},
  directives: {
    TableResizable
  },
  data: function () {
    return {
      clock: 0,
      loading: false,
      editMode: false,
      pagingCounter: 0,
      pagination: {
        rowsPerPage: 0, rowsNumber: 1000
      },
      optimalHeight: '100vh',
      lastQuery: null,
      doneLoading: false,
      rawData: [],
      query: {},

    };
  },
  computed: {
    lazyLoadEnabled() {
      return this.lazyLoader && !this.justSelectedAll;
    },
    workingKey() {
      return this.rowKeyField == 'auto' ? 'vkey' : this.rowKeyField
    },
    columnsProcessed() {
      if (this.colDefinitions) {
        let idx = 0
        return this.colDefinitions.map(col => {
          col.name = col.prop + (++idx)
          col.field = col.prop
          if (col.sortable === undefined) col.sortable = true
          return col
        })
      }
    },
    dataProcessed() {
      return this.rawData
    },
    queryParams() {
      return this.rQuery
    }
  },
  props: {

    formEditorEnabled: {
      type: Boolean,
      default: false
    },
    addEmptyLineIfEmpty: {
      type: Boolean,
      default: false
    },
    dispalyLineNumber: {
      type: Boolean,
      default: false
    },
    selectMode: {
      type: Boolean,
      default: false
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    noWrap: {
      type: Boolean,
      default: true
    },
    rowClassFactory: {
      type: Function,
      default: null
    },
    endPoint: {
      type: Function,
      default: null
    },
    editorcomponentFactory: {
      type: Function,
      default: null
    },
    selectable: {
      type: Function,
      default: null
    },
    cellClassFactory: {
      type: Function,
      default: null
    },
    editDisabled: {
      type: Boolean,
      default: false
    },
    selectionId: {
      default: null
    },
    rowKeyField: {type: String, default: "id"},
    selectedClass: {type: String, default: "selectedRow"},
    newClass: {type: String, default: "newRow"},
    mobileMode: {
      type: Boolean,
      default: false
    },
    allwaysEdit: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => []
    },
    modxProcessor: {
      type: String,
      default: null
    },

    rowHeight: {
      type: Number,
      default: 48
    },
    pagging: {
      type: Number,
      default: 40
    },
    topOffset: {
      type: Number,
      default: 5
    },
    expandComponent: {
      type: String,
      default: null
    },
    rQuery: {
      type: Object,
      default: () => {
      }
    },
    newRowData: {
      type: Object,
      default: () => null
    },

    lazyLoader: {
      type: Boolean,
      default: true
    },

    addEmptyLine: {
      type: Boolean,
      default: false
    },
    colDefinitions: {
      type: Array,
      default: () => []
    },
    defaultSort: {
      type: String,
      default: null
    },
    heightWish: {
      type: [String,
             Boolean],
      default: "tobottom"
    }
  },
  methods: {
    displayVal(val, props) {
      const colDefs = props.col
      let row = props.row
      // _log_('render val...', colDefs)
      // return  val
      const vm = this;

      if (!row || (row.idx && (row.idx + "").indexOf("gap") === 0)) return;
      if (colDefs.formatterType == "unxToDate") return this.formatDate(val);
      else if (colDefs.formatter) {
        return colDefs.formatter(val, colDefs, row, vm, this.tableData);
      }
      if (val === null || val === undefined) return "&nbsp;";
      if (colDefs.labelProp) val = row(colDefs.labelProp);

      const editor = colDefs.editorcomponent;
      if (editor)
        switch (editor.is) {
          case "s-select":
            if (!val || val == "" || val == 0) return "&nbsp;";
            if (editor.valueProp == "raw") return val;
            var avOptions = null;
            if (editor.optionsRepo) {
              avOptions = this.getList(editor.optionsRepo);
            }
            else avOptions = editor.options;

            var q = {};
            q[editor.valueProp] = val + "";
            var o = _.find(avOptions, q);
            if (o) return o[editor.labelProp];
            else {
              q[editor.valueProp] = val;
              o = _.find(avOptions, q);
              if (o) return o[editor.labelProp];
            }
            return "?" + val;
            break;

          default:
            break;
        }

      return val && val != "" ? val : "<div> &nbsp;</div>";
    },
    handleCellClick(scope) {
      //compatibility with s-table
      scope.col.property = scope.col.prop
      scope.column = scope.col
      this.$emit(
          'cell-clicked',
          scope
      )
    },
    cellClassProcessor(scope) {

      if (this.cellClassFactory) {
        //compatibility with s-table
        scope.col.property = scope.col.prop
        scope.column = scope.col
        return this.cellClassFactory(scope);
      }


      return null
    },
    calcHeight() {
      const vm = this;
      _log_(
          "hell height.999.",
          vm.heightWish,

          vm.topOffset
      );
      if (!vm.heightWish) {
        vm.optimalHeight = "";
        return;
      }
      this.$nextTick(function () {
        if (!vm.$refs.stable) return;
        const domEl = vm.$refs.stable.$el;
        var rect = domEl ? domEl.getBoundingClientRect() : null;
        vm.query = vm.rQuery;

        if (vm.isTouchDevice()) {
          this.$nextTick(function () {
            vm.optimalHeight = Math.round(window.innerHeight - rect.top - 5);
            if (vm.optimalHeight < 300) vm.optimalHeight = "100vh";
            // _log_("hell height.." + window.innerHeight);
            // vm.optimalHeight = window.innerHeight; //  - this.topOffset
            // vm.$refs.stable.doLayout();
          });

          return;
        }
        else {
          if (vm.heightWish == "tobottom") {
            vm.optimalHeight = Math.round(
                window.innerHeight - rect.top - vm.topOffset - 10
            );
            return;
          }
          else {
            if (vm.heightWish.indexOf("-") == 0) {
              vm.optimalHeight =
                  window.innerHeight - rect.top + parseInt(vm.heightWish);
            }
            else if (vm.heightWish.indexOf("%") > 0) {
              vm.optimalHeight =
                  (window.innerHeight * parseInt(vm.heightWish)) / 100;
            }
            else vm.optimalHeight = parseInt(vm.heightWish);
          }
          vm.optimalHeight = vm.optimalHeight - vm.topOffset;
        }
        _log_("hell height.FINALL." + vm.optimalHeight);
      });
    },
    async wakeUp(data) {
      _log_("check.go..more..0000.." + this.pagging, data);
      this.rawData = data ? data : this.value;
      ++this.clock
      this.calcHeight()
    },
    async loadData(reset) {
      if (reset) {
        this.pagingCounter = 0
        this.doneLoading = false
        this.rawData = []
      }
      if (this.doneLoading) return
      let data = await this.getServData();
      if (!data) {
        this.pagination = null
        return
      }
      this.pagination.rowsNumber = data.total
      if (!data.results || data.results.length < this.pagging)
        this.doneLoading = true;
      else this.doneLoading = false;
      if (this.rowKeyField == 'auto') {
        let idx = 0
        data.results = data.results.map(e => {
          e.vkey = ++idx
          return e
        })
      }
      this.rawData = this.rawData && this.rawData.length ? [...this.rawData,
                                                            ...data.results] : data.results;
      if (data) this.$emit("dataFetched", data);
    },
    async getServData(params, forceAll) {
      params = params ? params : {};
      params.limit = this.lazyLoadEnabled && !forceAll ? this.pagging : 0;
      if (!this.endPoint && !this.modxProcessor) return
      // if (!this.simpleLazyLoader) {
      //   params.start = this.topIdx ? this.topIdx - 1 : 0;
      // } else {
      //   params.start = this.pagingCounter * this.pagging;
      // }
      params.start = this.pagingCounter * this.pagging;
      this.loading = true
      if (this.modxProcessor) {

        const {data} = await api.fetchProcessor(this.modxProcessor, {
          ...this.rQuery,
          ...params
        });
        this.loading = false
        return data;
      }
      else if (typeof this.endPoint === "function") {
        const data = await this.endPoint(params);
        if (data.data) {
          this.loading = false
          return {results: data.data};
        }
        else {
          this.loading = false
          return {results: data};
        }
      }
      else {
        this.loading = false
        return {data: {results: []}};
      }
      this.loading = false
    },
    async onScroll({to, ref}) {
      const lastIndex = this.rawData.length - 1

      if (this.loading !== true && to === lastIndex) {

        ++this.pagingCounter
        await this.loadData()

      }
      // if (this.loading !== true && this.nextPage < lastPage && to === lastIndex) {
      // }
    }
  },
  async created() {
    await this.loadData()
  },
  watch: {
    rQuery: {
      handler: async function (newValue, oldVal) {
        _log_("test..newValue ", newValue);
        if (!this.modxProcessor) return;
        if (!!newValue && !!oldQuery) {
          let diffs = this.deepCompare(newValue, oldQuery)
          if (Object.keys(diffs).length === 0) {
            diffs = this.deepCompare(oldQuery, newValue)
            if (Object.keys(diffs).length === 0) return
          }
          _log_("test..getServData ", diffs, newValue, oldQuery);
        }
        else if (!newValue && !oldQuery) return

        oldQuery = newValue
        ++this.clock
        await this.loadData(true)
        // const comingQuery = this.safeSet(newValue);
        // if (newValue && !this.isQueryNew(comingQuery)) return;
        //
        // this.resetTableState();
        //
        // if (!newValue) {
        //   this.tableData = [];
        //   return;
        // }
        //
        // // if (!_.isEqual(this.query, newValue)) {
        // this.tableData = [];
        // _log_("comingQuery REG SQuery.", this.query);
        // this.query = comingQuery; // this.safeSet(newValue);
        // await this.reload();

        // await this.loadInfinite();
        // }
      },
      deep: true
    },
  }
}
</script >

<style lang="sass" >
.my-sticky-virtscroll-table
  /* height or max-height is important */
  max-height: calc(100vh - 100px)

.dark
  .q-table__top,
  .q-table__bottom, .dark

  thead tr:first-child th
    background-color: #2a5c69

  thead tr th
    position: sticky
    z-index: 1
  /* this will be the loading indicator */








  thead tr:last-child th
    /* height of all previous header rows */
    top: 48px

  thead tr:first-child th
    top: 0
</style >
